
import { mapState, mapMutations } from 'vuex'
export default {
  data() {
    return {
      initialLangParam: null, // hold URL param until plugin confirms
      initialHandled: false   // track when we’re done applying it
    }
  },
  mounted() {
    this.$nextTick(() => {
      // Detect ?lang query on first load
      const urlParams = new URLSearchParams(window.location.search)
      this.initialLangParam = urlParams.get('lang')
      if (this.initialLangParam) {
        this.setLoading(true) // show loader immediately if query param exists
      }
      // If script already exists (Nuxt head), just start polling
      this.checkLzLanguage()
    })
  },
  methods: {
    ...mapMutations(['setLanguage','setLoading']),
    switchLanguage(code) {
      this.setLoading(true) // show loader immediately
      try {
        // Always try to call LetzChat’s global function if available
        if (typeof lzSwitchLanguage !== 'undefined' && lzSwitchLanguage !== 'null') {
          lzSwitchLanguage(code) // tell LetzChat to switch
          console.log(`Called lzSwitchLanguage(${code})`)
        } else {
          console.warn('lzSwitchLanguage not ready yet')
        }
      } catch (err) {
        console.error('Error calling lzSwitchLanguage:', err)
      }
      // Don’t override plugin: wait for confirmation
      this.waitForPluginLang(code)
    },
    checkLzLanguage() {
      // Prevent multiple intervals if this component is mounted more than once
      if (window.__lzLanguageCheckInterval) return
      // Poll every 100ms to check if lzCurrentLanguage is defined
      window.__lzLanguageCheckInterval = setInterval(() => {
        try {
          if (typeof lzCurrentLanguage !== 'undefined' && lzCurrentLanguage !== 'null') {
            console.log('lzCurrentLanguage detected:', lzCurrentLanguage)
            if (this.initialLangParam && !this.initialHandled) {
              // On very first load, force plugin to match param
              if (lzCurrentLanguage !== this.initialLangParam) {
                console.log('Forcing plugin to match initial param:', this.initialLangParam)
                lzSwitchLanguage(this.initialLangParam)
                this.waitForPluginLang(this.initialLangParam, true)
              } else {
                // Already correct → update store and hide loader
                this.setLanguage(this.initialLangParam)
                this.setLoading(false)
                this.initialHandled = true // mark param as handled
              }
            } else {
              // After first load, always just sync with plugin
              this.setLanguage(lzCurrentLanguage)
              this.setLoading(false)
            }
            // Stop polling once plugin is ready
            clearInterval(window.__lzLanguageCheckInterval)
            window.__lzLanguageCheckInterval = null
          }
        } catch (error) {
          console.error('Error accessing lzCurrentLanguage:', error)
        }
      }, 100)
    },
    waitForPluginLang(expected, markHandled = false) {
      // Poll until plugin language actually matches what we want
      const interval = setInterval(() => {
        if (typeof lzCurrentLanguage !== 'undefined' && lzCurrentLanguage === expected) {
          console.log('Plugin finished switching to:', expected)
          this.setLanguage(expected)
          this.setLoading(false) // hide loader once confirmed
          if (markHandled) {
            this.initialHandled = true // drop query param control
          }
          clearInterval(interval)
        }
      }, 100)
      // Add timeout safeguard (5s) to prevent infinite loader
      setTimeout(() => {
        clearInterval(interval)
        this.setLoading(false)
        if (markHandled) this.initialHandled = true
      }, 5000)
    }
  },
  computed: {
    ...mapState(['language'])
  }
}
